(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Dawn default sticky header */
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure(); this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  /* Mobile overlay controller: overlays header only, announcement remains in flow */
  (function () {
    const sectionEl = document.querySelector('.section-header');
    if (!sectionEl) return;

    const wrapper = sectionEl.querySelector('.header-wrapper');
    const overlayEnabled = wrapper && wrapper.dataset.mobileOverlay === 'true';
    if (!overlayEnabled) return;

    const drawerDetails = sectionEl.querySelector('header-drawer details');
    const announcement  = sectionEl.querySelector('.announcement-bar');

    function setAnnouncementVars(){
      const h = announcement ? (announcement.offsetHeight || 0) : 0;
      sectionEl.style.setProperty('--ann-offset', h + 'px');
    }

    function applyOverlay() {
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      const atTop    = (window.scrollY || document.documentElement.scrollTop || 0) <= 1
                       && !sectionEl.classList.contains('scrolled-past-header');
      const menuOpen = !!(drawerDetails && drawerDetails.open);

      if (isMobile && atTop && !menuOpen) {
        sectionEl.classList.add('overlay-on');
      } else {
        sectionEl.classList.remove('overlay-on');
      }
      setAnnouncementVars();
    }

    window.addEventListener('scroll', applyOverlay, { passive: true });
    window.addEventListener('resize', applyOverlay);
    if (drawerDetails) drawerDetails.addEventListener('toggle', applyOverlay);

    applyOverlay();
  })();

  /* Add/remove 'at-top' when toggle enabled to hide logo on mobile/tablet (home only) */
  (function () {
    const sectionEl = document.querySelector('.section-header');
    if (!sectionEl) return;

    const wrapper = sectionEl.querySelector('.header-wrapper');
    const hideLogoTop = wrapper && wrapper.dataset.hideLogoTopMobile === 'true';
    if (!hideLogoTop) return;

    function updateTopState() {
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      const atTop =
        ((window.scrollY || document.documentElement.scrollTop || 0) <= 1) &&
        !sectionEl.classList.contains('scrolled-past-header');

      sectionEl.classList.toggle('at-top', isMobile && atTop);
    }

    window.addEventListener('scroll', updateTopState, { passive: true });
    window.addEventListener('resize', updateTopState);
    updateTopState();
  })();

  } catch(e) { console.error(e); }
})();
})();
